var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticStyle:{"padding":"0px !important"},attrs:{"cols":"12"}},[_c('SlideHolder'),_c('Products'),_c('SearchMD')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }